<script>
    import { t, locale, locales } from "../../../scripts/i18n";

    export let stage = {};
    export let setStage;

</script>

<div class="banner-wrap">
    <div class="banner-intro">
        {$t('Account cleaning paused. You can continue cleaning on the corresponding page.')}
    </div>

    <div class="btn-wrap">
        <a href="/demo/analyze-finished" class="mx-auto purple-btn purple-btn_hover w-190px h-45px">
            {$t('Cleaning progress')}
        </a>
    </div>
</div>